import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutDriverPayeeLookupMulticompany extends Layout {
    sourceDriverPayees: DataSource;
    tablePayees: Table;
}
